import React from "react";
import ContentFrequentlyAskedQuestions from "../../../ui-components/content-frequently-asked-questions/content-frequently-asked-questions.tsx";

const StratusFrequentlyAskedQuestions = () => {
  return (
    <div className="flex flex-col w-full py-6 max-w-full items-center ">
      <div className="flex flex-col gap-12 w-full max-w-3xl">
        <h1 className="w-full text-center font-bold text-3xl">
          Frequently Asked Questions
        </h1>

        <ContentFrequentlyAskedQuestions />
      </div>
    </div>
  );
};

export default StratusFrequentlyAskedQuestions;
